import { ROUTES } from 'src/router/const'

const routes = [
  {
    path: '/',
    name: ROUTES.APP,
    component: () => import('src/pages/AppIndex.vue'),
    redirect: '/' + ROUTES.LOGIN,
    children: [
      {
        path: '/' + ROUTES.LOGIN,
        name: ROUTES.LOGIN,
        component: () => import('src/pages/EmailLogin.vue'),
      },
      {
        path: '/' + ROUTES.GRANT_SELECT,
        name: ROUTES.GRANT_SELECT,
        component: () => import('src/pages/EmailGrantSelect.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/' + ROUTES.MAP,
        name: ROUTES.MAP,
        component: () => import('src/pages/EmailMap.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },

  // Handles map internal invites
  {
    path: `/link/:${ROUTES.PARAM.LINK_ID}`,
    name: ROUTES.LINK_LOGIN,
    component: () => import('src/pages/LinkInviteIndex.vue'),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
